import React, { useEffect } from 'react';
import type { SingleCommonType } from '../../types';
import { commonBackInfo } from '../../utils';
import { postStreamTypePlaceholder } from '../../constants/placeholder';
import CustomFollowerRange from '../../components/CustomFollowerRange';
import { commonDealwithData, useSetRangeDefaultValue } from '../../hooks/init';
import { useIntl } from 'umi';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function PostStreamRange({
  onChange,
  defaultValue,
  filterValue,
  defaultKey,
  oriDefaultFilter,
  backOriDefaultValue,
  lang,
}: SingleCommonType) {
  const { rangeValue, setRangeValue, followerRef, options, diffClassName } =
    useSetRangeDefaultValue({
      defaultValue,
      filterValue,
      defaultKey: 'posts',
      oriDefaultFilter,
      backOriDefaultValue,
      options: [
        { text: 'All', value: '-' },
        { text: '0 ~ 5', value: '0-5' },
        { text: '6 ~ 10', value: '6-10' },
        { text: '> 10', value: '10-' },
        { text: '> 20', value: '20-' },
      ],
      dealwithDateFunc: (item: {
        value: any;
        defaultKey: string;
        subDefaultKey?: string;
      }) =>
        commonDealwithData({
          ...item,
          dealwithValue: (value: number) => value,
          unit: '',
        }),
    });

  const { formatMessage } = useIntl();
  useEffect(() => {
    const showHeader = followerRef.current?.buttonElement?.(rangeValue);
    const data = [];
    if (rangeValue !== '-') {
      const [start, end] = rangeValue.split('-');
      const dataItem: { start_posts: number; end_posts?: number } = {
        start_posts: Number(start),
      };
      if (end !== '') {
        dataItem['end_posts'] = Number(end);
      }
      data.push(dataItem);
    }

    onChange?.(
      'postsRange',
      commonBackInfo({ posts: data }, { postsRange: showHeader }),
    );
  }, [rangeValue, formatMessage]);

  return (
    <div className={diffClassName}>
      <CustomFollowerRange
        lang={lang}
        ref={followerRef}
        options={options}
        setRangeValue={setRangeValue}
        rangeValue={rangeValue}
        placeholder={postStreamTypePlaceholder}
        unit={''}
        pointKey={FilterButtonPoint.postStream}
      ></CustomFollowerRange>
    </div>
  );
}
